module.exports = __webpack_public_path__ + "static/media/partner_zhaoshangyinhang.48e04be2.png";